import React from 'react';

const ArrowIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="9.969"
    viewBox="0 0 6 9.969"
    style={{ fillRule: 'evenodd' }}
    {...props}
  >
    <path
      d="M785.783,854.5l-4.552,4.3a0.771,0.771,0,0,1-1.048,0,0.672,0.672,0,0,1,0-.99L784.21,854l-4.027-3.8a0.672,0.672,0,0,1,0-.99,0.773,0.773,0,0,1,1.048,0l4.552,4.3A0.674,0.674,0,0,1,785.783,854.5Z"
      transform="translate(-780 -849.031)"
    />
  </svg>;

export default ArrowIcon;



// WEBPACK FOOTER //
// ./app/components/breadcrumbs/arrow-icon.js